<h4 class="modal-title pull-left">Pres OK to Close Gate</h4>
